import { styled } from '@mui/material'
const StyledDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',

  [theme.breakpoints.down('md')]: {
    width: '100%',
    paddingLeft: '0.4rem'
  }
}))
export default StyledDiv
